export default "__VITE_ASSET__BdgwRodJ__"